import type { SortOrder } from './types';

/** Compares branded sort orders lexicographically, matching ULID chronological order. */
export function compareSortOrders(a: SortOrder, b: SortOrder): number {
  return a < b ? -1 : a > b ? 1 : 0;
}
